<template>
  <PullRefresh
    v-model="isLoading"
    success-text="刷新成功"
    :disabled="disabledPull || !isLive"
    @refresh="onRefresh"
  >
    <!-- 未开始-0 或 已结束-2  -->
    <div
      v-if="!isLive"
      class="pageNative"
    >
      <!-- <img
        v-if="isNotOpen"
        :src="`${CDN_URL_1}/box_subscribe/unStart.png`"
      /> -->
      <div v-if="isNotOpen" class="nativeStatus">
        活动将于 {{ activityInfo.startTime }} 开始
      </div>
      <!-- <img
        v-if="isPassed"
        :src="`${CDN_URL_1}/box_subscribe/end.png`"
      /> -->
      <div v-if="isPassed" class="nativeStatus">
        活动已结束
      </div>
    </div>
    <!-- 进行中-1  -->
    <div
      v-else
      class="page bg_contain_bot"
      :style="{
        [curGameInfo.enterStatus === 1 ? 'backgroundImage' : 'backgroundColor']: bg,
      }"
    >
      <div
        class="page_banner bg_contain"
        :style="{
          backgroundImage: `url(${activityInfo.icon})`
        }"
      >
      </div>
      <div class="page_main">
        <div class="page_nav">
          <div class="page_games">
            <div
              v-for="gm in theTop4Games"
              :key="gm.gameId"
              class="page_game"
              :class="{ 
                page_game_active: gm.gameId === activeGameId,
                active_text: gm.gameId === activeGameId
              }"
              @click="handleChangeActiveGame(gm)"
            >
              <div
                class="page_game_icon bg_contain"
                :style="{
                  backgroundImage: `${gm.gameId === activeGameId ? `url(${CDN_URL_1}/box_wxRegister/selected.png),` : ''}url(${gm.gameIcon})`
                }"
              ></div>
              <div class="page_game_name scale09_center">{{ gm.gameName }}</div>
            </div>
          </div>
          <div class="page_more" @click="triggerMoreGame(true)">
            <div
              class="page_game_icon bg_contain"
              :style="{
                backgroundImage: `url(${CDN_URL_1}/box_wxRegister/more.png)`
              }"
            ></div>
            <div class="page_game_name scale09_center active_text">更多游戏</div>
          </div>
        </div>
        <div class="page_ctn">
          <!-- case1: 所选游戏无进入记录 -->
          <div v-if="curGameInfo.enterStatus === 1" class="page_ctn_wrap">
            <div class="page_ctn_desc">
              <!-- <p>下载《{{ curGameInfo.gameName }}》创角后</p>
              <p>解锁18888福袋</p> -->
            </div>
            <div class="page_ctn_btn" @click="handleDownload(true)">
              立即下载
            </div>
          </div>
          <!-- case2: 所选游戏中首次进入游戏时间在活动开始时间之前 -->
          <div v-if="curGameInfo.enterStatus === 0" class="page_ctn_wrap">
            <div class="page_ctn_status0">
              <p>您在《{{ curGameInfo.gameName }}》中已有历史创角，</p>
              <p>福利仅限游戏新用户领取，</p>
              <p>去其他游戏会场看看吧~</p>
            </div>
          </div>
          <!-- case3: 所选游戏中首次进入游戏时间在活动期间范围内 -->
          <div
            v-if="curGameInfo.enterStatus === 2"
            class="page_ctn_wrap"
            @touchstart="disabledPull = true"
            @touchend="disabledPull = false"
          >
            <div class="page_ctn_gifts">
              <div
                v-for="gf in welfareList"
                :key="gf.welfareId"
                class="page_ctn_gf"
              >
                <div
                  class="page_ctn_gf_icon bg_contain"
                  :style="{
                    backgroundImage: `url(${gf.giftIcon})`
                  }"
                ></div>
                <div class="page_ctn_gf_desc">
                  <div class="page_ctn_gf_name">{{ gf.giftName }}</div>
                  <div class="page_ctn_gf_detail van-multi-ellipsis--l2">{{ gf.giftContent }}</div>
                </div>
                <div class="page_ctn_gf_oper">
                  <div
                    class="page_ctn_gf_btn"
                    :class="{
                      received: gf.status === 1
                    }"
                    @click="handleReceiveGift(gf)"
                  >
                    {{ gf.status === 0 ? '领取' : '已领取' }}
                  </div>
                  <div class="page_ctn_gf_tip scale09_center">{{ gf.condition }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ActivityDialog
      title="解锁成功"
      :visible="visibleOfPopup"
      hideCancel
      sureText="立即领取"
      @click-cancel="triggerPopup(false)"
      @click-sure="handleSurePopup"
    >
      <template #main>
        <div class="popup">
          <div
            class="popup_icon bg_contain"
            :style="{
              backgroundImage: `url(${CDN_URL_1}/box_wxRegister/18888.png)`
            }"
          ></div>
          <div class="popup_desc">
            <p>恭喜解锁！</p>
            <p style="position: relative">
              18888元福袋
              <b class="popup_mini">活动页面</b>
            </p>
          </div>
        </div>
      </template>
    </ActivityDialog>
    <ActivityDialog
      title="更多游戏"
      :visible="visibleOfMoreGame"
      hideCancel
      hideSure
      @click-cancel="triggerMoreGame(false)"
    >
      <template #main>
        <div class="more_wrap">
          <p class="active_text">请选择</p>
          <div class="more_games">
            <div
              v-for="gm in gameList"
              :key="gm.gameId"
              class="more_game"
              @click="handleClickGame(gm)"
            >
              <div
                class="more_game_icon bg_contain"
                :style="{
                  backgroundImage: `url(${gm.gameIcon})`
                }"
              ></div>
              <div class="more_game_name scale09_center">{{ gm.gameName }}</div>
            </div>
          </div>
        </div>
      </template>
    </ActivityDialog>
    <ActivityDialog
      :title="dialogTitle"
      :visible="dialogVisible"
      :hideCancel="true"
      :sureText="sureText"
      @click-sure="onSureDialog"
      @click-cancel="dialogVisible = false"
      :herderStyle="{ background: 'linear-gradient(90deg, #ff782c 0%, #ffb503 100%)' }"
      :dialogStyle="{ top: dialogType == 1 ? '16%' : '32%' }"
    >
      <template v-slot:main>
        <!-- 不满足活动条件 -->
        <div v-if="dialogType == 1" class="dialog2">
          <p :style="{textAlign: 'center'}">活动期间在该游戏内充值订单数量达{{ curWelfareInfo.conditionValue }}笔即可领取礼包</p>
          <div class="progress">
            <p class="text">当前进度</p>
            <p
              class="percentage"
              :style="{ width: percentageVal + '%' }"
            ></p>
            <p
              v-if="percentageVal < 100"
              class="amount"
              :style="{ left: (percentageVal == 0 ? 1 : percentageVal - 1) + '%' }"
            >
              {{ amount }}
            </p>
            <p class="typeValue">{{ curWelfareInfo.conditionValue }}</p>
          </div>
        </div>
        <!-- 领取成功 -->
        <div v-if="dialogType == 2" class="dialog3">
          <p :style="{textAlign: 'center', marginBottom: '10px'}">礼包码已存放在</p>
          <p :style="{textAlign: 'center', width: '100%'}"><span>【我的】</span>-<span>【我的礼包】</span>-<span>【活动礼包】</span></p>
        </div>
        <!-- 礼包码生成错误 -->
        <div v-if="dialogType == 3" class="dialog4">
          <p :style="{textAlign: 'center'}">兑换码生成错误，请联系客服领取备用码</p>
        </div>
      </template>
    </ActivityDialog>
  </PullRefresh>
</template>

<script>
import {
  setPageTitle,
  toLogin,
  jumpToNative,
  clickRightTxt,
  setRightTxtColor,
  setRightTxt,
  loginSuccess,
  phoneBackButtonListener,
} from "@/bridge/AppJsBridge";
import { PullRefresh } from "vant";
import {
  getRegisterActApi,
  getRegisterGamesApi,
  getRegisterWelfareApi,
  drawRegisterWelfareApi,
} from '@/apis/wxActivity'
import ActivityDialog from "@/components/btBox/ActivityDialog";
import EventTrack from '@/mixins/eventTrack'
import { CDN_URL_1 } from "@/config";

export default {
  components: {
    PullRefresh,
    ActivityDialog,
  },
  mixins: [EventTrack],
  data () {
    return {
      isWx: true,
      CDN_URL_1,
      isLoading: false,
      activeGameId: '',
      gameList: [], // 游戏会场列表
      welfareList: [], // 福利列表
      activityInfo: {
        id: '',
        startTime: "",
        title: "",
        icon: "",
        endTime: "",
      },
      visibleOfMoreGame: false,
      visibleOfPopup: false,
      drawLoading: false,
      dialogVisible: false,
      dialogType: 1, // 1-不满足领取条件 2-领取成功 3-礼包码生成错误
      dialogTitle: '更多游戏',
      sureText: '',
      percentageVal: 0,
      disabledPull: false, // 禁用下拉刷新
      saveExtraParam: {}, // tracking -> 保存额外的参数
      curWelfareInfo: {},
    }
  },
  computed: {
    activityId () {
      return this.activityInfo.id
    },
    isLive () {
      if (!this.activityInfo.id) return false
      return !this.isPassed && !this.isNotOpen
    },
    isPassed () {
      const { endTime } = this.activityInfo
      const THIS_MOMENT = Date.now()
      return new Date(endTime).getTime() < THIS_MOMENT
    },
    isNotOpen () {
      const { startTime } = this.activityInfo
      const THIS_MOMENT = Date.now()
      return new Date(startTime).getTime() > THIS_MOMENT
    },
    curGameInfo () {
      return this.gameList.find(it => it.gameId === this.activeGameId) || {}
    },
    // 排序前 4 的游戏  并且将选中的游戏放到第一位
    theTop4Games () {
      const gList = this.gameList
      if (!Array.isArray(gList) || !gList.length) return []
      const maxCount = 4
      const currentIdx = gList.findIndex(it => it.gameId === this.activeGameId)
      const res = [gList[currentIdx]]
      gList.forEach(it => {
        if (res.length === maxCount) return
        if (it.gameId === this.activeGameId) return
        res.push(it)
      })
      return res
    },
    bg () {
      const { enterStatus, icon } = this.curGameInfo
      if (enterStatus === 1) return `url(${icon})`
      if (enterStatus === 0) return '#B1B1B1'
      return '#F6F6F6'
    },
    // 常用的埋点参数
    commonTrackParams () {
      const { id, title } = this.activityInfo
      const { gameId, gameName, enterStatus, placeId } = this.curGameInfo
      return {
        id,
        title,
        game_id: gameId,
        game_name: gameName,
        type: enterStatus,
        place_id: placeId,
      }
    },
  },
  watch: {
    curGameInfo: {
      handler (val) {
        const { enterStatus } = val
        if (enterStatus === 2) {
          this.getWelfareList()
        }
      },
      deep: true
    },
  },
  mounted () {
    // 如果浏览器没有调用接口，可以加上 IS_DEV 的 query 参数
    const { query } = this.$route
    if (query.IS_DEV) {
      this.init()
    }
    this.getAppToken(true)
  },
  activated () {
    setPageTitle(this.activityInfo.title)
    if (!this.isLive) return
    this.setHeaderContent();
  },
  methods: {
    onRefresh () {
      this.init().then(res => {
        this.isLoading = false
      })
    },
    getActivityInfo () {
      this.init()
    },
    init () {
      return this.getActInfo().then(res => {
        setPageTitle(this.activityInfo.title)
        if (!this.isLive) return
        // 活动不在进行中，则不展示活动规则
        this.setHeaderContent();
        return this.getGames()
      })
    },
    // 获取活动详情
    getActInfo () {
      return getRegisterActApi().then(res => {
        this.activityInfo = res.data
        this.eventTrack({
          event: 'register_active',
          event_field: JSON.stringify({
            title: res.data.title,
            id: res.data.id,
          })
        })
      })
    },
    // 获取活动下游戏会场列表
    getGames () {
      return getRegisterGamesApi({ activityId: this.activityId }).then(res => {
        this.gameList = res.data
        if (res.data.length) {
          this.handleChangeActiveGame(res.data[0])
        }
      }).catch((err) => {
        if (err.response && err.response.data.code === 401) {
          toLogin("/loginKey/LoginByKeyPhoneActivity")
        }
      })
    },
    getWelfareList () {
      // 期间进入方可展示福利列表
      if (this.curGameInfo.enterStatus !== 2) return 
      return getRegisterWelfareApi({
        activityId: this.activityId,
        placeId: this.curGameInfo.placeId
      }).then(res => {
        const { list, popup } = res.data
        this.welfareList = list
        if (!popup) {
          // 服务端决策：弹窗弹出时需要再请求一次
          this.getWelfareList()
          this.eventTrack({
            event: 'register_active_first_popup',
            event_field: JSON.stringify({
              ...this.commonTrackParams
            })
          })
          this.triggerPopup(true)
        }
      })
    },
    // 切换所选游戏
    handleChangeActiveGame (gm) {
      const { gameId, gameName, enterStatus, placeId } = gm
      this.activeGameId = gameId
      this.eventTrack({
        event: 'register_active_place',
        event_field: JSON.stringify({
          title: this.activityInfo.title,
          id: this.activityInfo.id,
          game_id: gameId,
          game_name: gameName,
          type: enterStatus,
          place_id: placeId,
        })
      })
    },
    handleClickGame (gm) {
      this.triggerMoreGame(false)
      this.handleChangeActiveGame(gm)
    },
    handleReceiveGift (gf) {
      if (this.drawLoading) return
      this.saveExtraParam =  {
        welfare_id: gf.welfareId,
        gift_name: gf.giftName,
        condition_value: gf.conditionValue,
      }
      this.eventTrack({
        event: 'register_active_welfare_click',
        event_field: JSON.stringify({
          ...this.commonTrackParams,
          ...this.saveExtraParam,
        })
      })
      this.curWelfareInfo = gf
      if (gf.status === 1) {
        this.openDialog(2)
        return
      }
      this.drawLoading = true
      drawRegisterWelfareApi({
        activityId: this.activityId,
        placeId: this.curGameInfo.placeId,
        welfareId: gf.welfareId,
      })
        .then(res => {
          const { code, data, msg } = res
          // data -> 礼包码，有则成功，没有则报错礼包码生成错误，联系客服去
          this.openDialog(data ? 2 : 3, true)
          // 更新福利列表
          this.getWelfareList()
        })
        .catch(err => {
          const { code, data, msg } = err
          // 付费笔数不够
          if ([92007].includes(code)) {
            this.percentageVal = msg / gf.conditionValue * 100
            this.amount = msg * 1
            this.saveExtraParam.current_value = msg
            this.openDialog(1, true)
          }
          // 没有查询到游戏记录
        })
        .finally(() => this.drawLoading = false)
    },
    openDialog (type, hasEvent = true) {
      this.dialogVisible = true;
      this.dialogType = type;
      if (type === 1) {
        this.dialogTitle = '不满足领取条件';
        this.sureText = '去完成';
      }
      if (type === 2) {
        this.dialogTitle = '领取成功';
        this.sureText = '查看兑换码';
        if (!hasEvent) {
          return
        }
      }
      if (type === 3) {
        this.dialogTitle = '提示';
        this.sureText = '联系客服';
      }
      this.eventTrack({
        event: "register_active_welfare_popup",
        event_field: JSON.stringify({ 
          ...this.commonTrackParams,
          scene_type: type - 1,
          ...this.saveExtraParam,
        }),
      });
    },
    onSureDialog () {
      if (this.dialogType === 1) {
        this.handleDownload()
      }
      if (this.dialogType === 2) {
        this.onGoGiftDetail()
      }
      if (this.dialogType === 3) {
        this.onRelationServer()
      }
      this.dialogVisible = false;
      if ([1, 2].includes(this.dialogType)) {
        this.eventTrack({
          event: "register_active_welfare_popup_click",
          event_field: JSON.stringify({ 
            ...this.commonTrackParams,
            scene_type: this.dialogType - 1,
            ...this.saveExtraParam,
          }),
        });
      }
    },
    // 礼包详情
    onGoGiftDetail() {
      const data = {
        routePath: "/gift/MineGiftActivity",
        extraParams: 3, 
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
    },
    // 联系客服
    onRelationServer() {
      this.dialogVisible = false;
      this.$router.push({
        name: `box.customerService`,
      });
    },
    triggerMoreGame (f = true) {
      this.visibleOfMoreGame = f
    },
    handleSurePopup () {
      this.eventTrack({
        event: 'register_active_first_popup_click',
        event_field: JSON.stringify({
          ...this.commonTrackParams
        })
      })
      this.triggerPopup(false)
    },
    triggerPopup (f = true) {
      this.visibleOfPopup = f
    },
    handleDownload (tracking) {
      this.handleGoGameDetail()
      if (tracking) {
        this.eventTrack({
          event: 'register_active_download_click',
          event_field: JSON.stringify({
            ...this.commonTrackParams
          })
        })
      }
    },
    // 跳转游戏详情
    handleGoGameDetail () {
      const data = {
        routePath: "/main/game/GameDetailActivity",
        fromPageType: 53,
        extraParams: this.curGameInfo.gameId,
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
    },
    // 设置顶部内容
    setHeaderContent() {
      setRightTxtColor("#6879AD");
      setRightTxt("活动规则");
      clickRightTxt(() => {
        this.$router.push({
          name: `box.actPlaceRule`,
          params: {
            type: 'register_act',
            activeRule: this.activityInfo.remark
          },
        });
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.page {
  width: 100vw;
  height: 100vh;
  padding: 8px 16px;
}
.page_banner {
  width: 100%;
  height: 177px;
  margin-bottom: 16px;
}
.page_main {
  height: calc(100vh - 177px - 16px - 16px);
}
.page_ctn {
  position: relative;
  margin-top: 16px;
  height: calc(100% - 84px - 16px - 8px);
  overflow: auto;
  .page_ctn_btn {
    position: absolute;
    bottom: 34px;
    left: 50%;
    transform: translateX(-50%);
    width: 262px;
    font-size: 20px;
    text-align: center;
    background: #FF9916;
    padding: 16px;
    color: #fff;
    border-radius: 26px;
  }
}
.page_nav {
  position: relative;
  display: flex;
  height: 84px;
  padding: 16px 68px 6px 14px;
  background: #fff3ea;
  border-radius: 5px;
}
.page_more {
  position: absolute;
  bottom: 6px;
  right: 12px;
}
.page_games {
  display: flex;
}
.page_game {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 64px;
  opacity: .64;
}
.page_game_icon {
  width: 46px;
  height: 46px;
  margin-bottom: 4px;
  transition: 0.15s all ease;
  border-radius: 6px;
}
.page_game_name {
  font-size: 12px;
  white-space: nowrap;
}
.page_game_active {
  opacity: 1;
  .page_game_icon {
    transform: scale(1.26);
    transform-origin: 50% 100%;
    border-radius: 10px;
  }
}
.active_text {
  color: #FF2504;
}
.page_ctn_status0 {
  margin-top: 120px;
  p {
    text-align: center;
    line-height: 1.25;
  }
}

// 更多游戏
.more_wrap {
  margin-top: -20px;
  .more_games {
    display: flex;
    flex-wrap: wrap;
    padding: 0 27px;
    margin-top: 12px;
    max-height: 260px;
    overflow: auto;
    .more_game {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 84px;
      margin-bottom: 8px;
      .more_game_icon {
        width: 58px;
        height: 58px;
        margin-bottom: 5px;
        border-radius: 6px;
      }
      .more_game_name {
        font-size: 12px;
      }
    }
  }
}
.page_ctn_gifts {
  // margin-top: 18px;
  overflow: auto;
  .page_ctn_gf + .page_ctn_gf {
    margin-top: 8px;
  }
  .page_ctn_gf {
    display: flex;
    background: #ffffff;
    border-radius: 7px;
    padding: 6px 8px 6px 12px;
  }
  .page_ctn_gf_icon {
    width: 64px;
    height: 64px;
    border-radius: 5px;
    margin-right: 8px;
  }
  .page_ctn_gf_desc {
    flex: 1;
    .page_ctn_gf_name {
      font-size: 16px;
      margin-top: 10px;
      margin-bottom: 4px;
      font-weight: bold;
    }
    .page_ctn_gf_detail {
      font-size: 12px;
      color: #9F5829;
    }
  }
  .page_ctn_gf_oper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .page_ctn_gf_btn {
    width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background: #D41D02;
    color: #fff;
    border-radius: 15px;
    margin-bottom: 4px;
  }
  .page_ctn_gf_btn.received {
    background: #919191;
  }
  .page_ctn_gf_tip {
    font-size: 12px;
    color: #DE482B;
    white-space: nowrap;
  }
}

.popup {
  display: flex;
  flex-direction: column;
  align-items: center;
  .popup_icon {
    width: 80px;
    height: 78.5px;
  }
  .popup_mini {
    position: absolute;
    font-size: 12px;
    border: 1px solid #333;
    line-height: 1;
    right: 16px;
    bottom: 0;
    transform: scale(.5);
    transform-origin: 0 0;
  }
}
.dialog2{
  .progress {
    height: 8px;
    // background: #d43e41;
    border-radius: 8px;
    border: 1px solid #c73534;
    width: 80%;
    margin: 40px auto 50px;
    position: relative;
    .percentage {
      height: 7px;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      background: linear-gradient(90deg, #ff756a 0%, #ffb46b 100%);
      border-radius: 6px;
    }
    .text {
      font-size: 12px;
      color: #747474;
      font-weight: 500;
      position: absolute;
      top: -22px;
      width: auto;
      left: 0;
    }
    .amount {
      font-size: 12px;
      color: #c73534;
      font-weight: 500;
      position: absolute;
      top: 8px;
      width: auto;
      // margin-left: -10px;
      transform: translateX(-50%);
    }
    .amount::before{
      content: ".";
      position: absolute;
      top: -11px;
      left: 50%;
    }
    .typeValue {
      font-size: 12px;
      color: #c73534;
      font-weight: 500;
      position: absolute;
      right: -10px;
      top: 8px;
      width: auto;
      transform: translateX(-50%);
    }
  }
  .progress::before {
    content: ".";
    color: #c73534;
    position: absolute;
    top: 0px;
    right:0%;
  }
}

.nativeStatus {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>